import { render, staticRenderFns } from "./CourseIntroduct.vue?vue&type=template&id=0405c7e8&scoped=true&"
import script from "./CourseIntroduct.vue?vue&type=script&lang=js&"
export * from "./CourseIntroduct.vue?vue&type=script&lang=js&"
import style0 from "./CourseIntroduct.vue?vue&type=style&index=0&id=0405c7e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0405c7e8",
  null
  
)

export default component.exports